module.exports = __webpack_public_path__ + "static/media/the_mungo_png.16828fcc.png";